import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './src/app.js'

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// Register service worker for PWA support
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed: ', error);
      });
  });
}
